import React from "react";
import { useTranslation } from "react-i18next";
import { etiquetaEscala } from "../utils/escalaRespuesta";
import styles from "../styles/encuesta4c.module.css";

const VALUES = [0, 1, 2, 3, 4, 5, 6];

export default function SurveyScaleOptions({ selectedOption, onSelect }) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.optionsDesktop}>
        <div className={styles.optionsBlock}>
          <div className={styles.optionsNumbersRow}>
            {VALUES.map((value) => (
              <button
                key={value}
                type="button"
                className={`${styles.optionButton} ${
                  selectedOption === value ? styles.optionButtonSelected : ""
                }`}
                aria-label={`${value}, ${etiquetaEscala(value, t)}`}
                onClick={() => onSelect(value)}
              >
                <span className={styles.optionValue}>{value}</span>
              </button>
            ))}
          </div>
          <div className={styles.optionsLabelsRow} aria-hidden="true">
            {VALUES.map((value) => (
              <span
                key={value}
                className={`${styles.optionScaleLabel} ${
                  selectedOption === value ? styles.optionScaleLabelSelected : ""
                }`}
              >
                {etiquetaEscala(value, t)}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.mobileOptions}>
        {VALUES.map((value) => (
          <button
            key={value}
            type="button"
            className={`${styles.mobileOptionButton} ${
              selectedOption === value ? styles.mobileOptionSelected : ""
            }`}
            aria-label={`${value}, ${etiquetaEscala(value, t)}`}
            onClick={() => onSelect(value)}
          >
            <span className={styles.mobileOptionNumber}>{value}</span>
            <span className={styles.mobileOptionLabel}>{etiquetaEscala(value, t)}</span>
          </button>
        ))}
      </div>
    </>
  );
}
